import { createElement } from 'react';
import PropTypes from 'prop-types';
import IconExcel from '../public/images/excel.svg';
import IconJpg from '../public/images/jpg.svg';
import IconPdf from '../public/images/pdf.svg';
import IconPng from '../public/images/png.svg';
import IconPpt from '../public/images/ppt.svg';
import IconWord from '../public/images/word.svg';
import IconHtml from '../public/images/html.svg';

const icons = {
  excel: IconExcel,
  jpg: IconJpg,
  pdf: IconPdf,
  png: IconPng,
  ppt: IconPpt,
  word: IconWord,
  html: IconHtml,
};

const FileIcon = ({ type, ...props }) => {
  if (Object.prototype.hasOwnProperty.call(icons, type)) {
    return createElement(icons[type], props);
  }

  return null;
};

FileIcon.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.oneOf([
      'excel',
      'jpg',
      'pdf',
      'png',
      'ppt',
      'word',
      'html',
    ]),
    PropTypes.string,
  ]).isRequired,
};

export default FileIcon;
